import {
  LoadingController,
  NavController,
  MenuController,
  ToastController,
  ModalController,
  Platform,
} from "@ionic/angular";
import { Injectable } from "@angular/core";
import { GlobalProvider } from "src/services/global";
// import { Storage } from "@ionic/storage";
import { Preferences } from "@capacitor/preferences";
import { NavigationExtras } from "@angular/router";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { ImageComponent } from "./components/image/image.component";
import { Capacitor } from "@capacitor/core";
import { FcmService } from "src/services/fcm.service";
@Injectable({
  providedIn: "root",
})
export class BaseHelper {
  gLoading;
  platformMode;
  constructor(
    private platform: Platform,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected modalCtrl: ModalController,
    protected navCtrl: NavController,
    protected g: GlobalProvider,
    protected menu: MenuController,
    // protected iStorage: Storage,
    private iab: InAppBrowser
  ) {
    this.initLoadLoading();
    // console.log(`platform?`, this.platform.is("desktop"));
    if (this.platform.is("desktop")) {
      this.platformMode = `desktop`;
    }
  }
  menuOpen() {
    this.menu.enable(false);
  }
  menuClose() {
    this.menu.enable(false);
    // this.menu.enable(false);
  }
  openTab(url) {
    // console.log(`platform?`, this.platform.is('desktop'));
    // const t = this.iab.create(url, "_blank");
    const t = this.iab.create(
      url,
      "_blank",
      "toolbarposition=top, lefttoright=yes"
    );
    return t;
  }
  openExternalLink(url) {
    window.open(url, "_blank");
  }
  // FOR SAFARI USERS
  // openTab(url) {
  //   console.log(`platform?`, this.platform.is('desktop'));
  //   window.open(url, '_blank');
  // }

  async image(oneImage) {
    const modal = await this.modalCtrl.create({
      component: ImageComponent,
      componentProps: { oneImage },
    });
    await modal.present();
  }
  async toast(message, duration = 2000, color = `success`) {
    const toast = await this.toastController.create({
      message,
      duration,
      color,
      buttons: [
        {
          icon: "close",
          role: "cancel",
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  async danger(message, duration = 2000) {
    const toast = await this.toastController.create({
      message,
      duration,
      color: `danger`,
      buttons: [
        {
          icon: "close",
          role: "cancel",
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }

  async toastUp(message, duration = 2000, color = `success`) {
    const toast = await this.toastController.create({
      message,
      duration,
      color,
      position: `top`,
      buttons: [
        {
          icon: "close",
          role: "cancel",
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  async initLoadLoading() {
    this.gLoading = await this.loadingCtrl.create({
      message: "Please Wait...",
      duration: 5000,
    });
  }
  async loadLoading(toggle = true) {
    if (toggle) {
      if (!this.gLoading) {
        await this.initLoadLoading();
      }
      this.gLoading.present();
    } else {
      if (this.gLoading) {
        await this.gLoading.dismiss();
      }

      this.initLoadLoading();
    }
    return;
  }

  // setStorage(key, value) {
  //   if (Capacitor.getPlatform() === "web") {
  //     // console.log(`using ionic storage`);
  //     // this.iStorage.set(key, value);
  //   } else {
  //     // console.log(`using cap storage`);
  //     Preferences.set({ key, value: JSON.stringify(value) });
  //     // console.log(`key?`, JSON.stringify(value));
  //   }
  // }
  async setStorage(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  getStorage(key: any) {
    const dat = localStorage.getItem(key);
    console.log("dat?",dat)
    console.log("key?",key)
    if(dat === 'undefined'){ 
      return null
    }
    if (dat) {
      return JSON.parse(dat)
    } else {
      console.log("null")
      return null
    }
  }
  // async getStorage(key) {
  //   if (Capacitor.getPlatform() === "web") {
  //     // console.log(`taking from ionic storage`);
  //     // return await this.iStorage.get(key);
  //   } else {
  //     // console.log(`taking from  cap storage`);
  //     const { value } = await Preferences.get({ key });
  //     // console.log(`key?`, value);
  //     return JSON.parse(value);
  //   }
  // }
  setJws(accessToken, profile, mediaUrl) {
     console.log("accessToken?",accessToken)
    // console.log(`profile`, profile);
    this.setStorage('companyCustomerToken', accessToken);
    this.g.jws = accessToken;
    this.g.profile = profile;
    // this.g.profileType = tokenObj.profileType;
    this.g.role = profile.role;
    this.g.accessRole = profile.accessRole;
    this.g.mediaUrl = mediaUrl;
   
    // if (accessToken) {
    //   this.setStorage("companyToken", accessToken);
    //   this.g.jws = accessToken;
    //   this.g.profile = profile;
    //   this.g.mediaUrl = mediaUrl;
    // } else {
    //   this.setStorage("companyToken", accessToken);
    //   this.g.jws = accessToken;
    //   this.g.profile = profile;
    //   this.g.mediaUrl = mediaUrl;
    // }
    // console.log("this.g.profile",this.g.profile)

  }
  clearJws() {
    this.setStorage("companyCustomerToken", null);
    this.g.jws = null;
    this.g.profile = null;
    // this.g.notifications = [];
    this.g.accessRole = null;
    this.g.role = null;
  }
  async getJws() {
    return await this.getStorage("companyCustomerToken");
  }
  async navigateRoot(path, queryParams = null) {
    if (queryParams) {
      const navigationExtras: NavigationExtras = {
        queryParams,
      };
      this.navCtrl.navigateRoot(path, navigationExtras);
    } else {
      this.navCtrl.navigateRoot(path);
    }
  }
  navigate(path, queryParams = null) {
    this.navCtrl.navigateForward(path, { queryParams });
  }

  pop() {
    this.navCtrl.pop();
  }
}
